<template>
  <ModalBootstrap
    id-modal="modalConfirmation"
    class="criteria"
    :title="title"
    :modal-size="modalSize"
    @close="onClose"
    data-cy="confirmation-modal"
  >
    <template #body>
      <div class="mx-2 mb-2 d-flex flex-column justify-content-center">
        <div class="my-5 text-center w-100 font-size-16" data-cy="modal-message">
          {{ message }}
        </div>

        <div class="row justify-content-center">
          <div class="col-md-6 px-2 text-center">
            <button
              class="btn btn-primary w-75 px-1 mb-1"
              @click.prevent="onClose"
              data-cy="cancel-button"
            >
              {{ $t("modal.cancel") }}
            </button>
          </div>
          <div class="col-md-6 px-2 text-center">
            <button
              class="btn btn-primary w-75 px-1 mb-1"
              @click.prevent="onConfirm"
              data-cy="confirm-button"
            >
              {{ $t("modal.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalBootstrap>
</template>

<script>
import ModalBootstrap from "@/components/modal/ModalBootstrap"

export default {
  name: "ModalConfirmation",
  components: { ModalBootstrap },
  props: ["message", "title", "modalSize"],
  methods: {
    onClose() {
      this.$emit("close")
    },
    onConfirm() {
      this.$emit("confirm")
    },
  },
}
</script>
